(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      connectedCallback() {
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.items = Array.from(this.querySelectorAll('.faq__item'));
        this.items.forEach((item) => {
          const panel = item.querySelector('.faq__panel');
          item.classList.toggle('is-expanded', item.open);
          panel?.classList.toggle('is-expanded', item.open);
          item.querySelector('summary')?.addEventListener('click', this.onSummaryClick);
        });
      }

      disconnectedCallback() {
        this.items.forEach((item) => {
          item.querySelector('summary')?.removeEventListener('click', this.onSummaryClick);
        });
      }

      onSummaryClick(event) {
        event.preventDefault();
        const item = event.currentTarget.closest('.faq__item');
        if (!item) return;
        this.toggleItem(item, !item.classList.contains('is-expanded'));
      }

      toggleItem(item, shouldOpen) {
        const panel = item.querySelector('.faq__panel');
        this.clearPendingClose(item);

        if (!panel || this.reduceMotion.matches) {
          item.open = shouldOpen;
          item.classList.toggle('is-expanded', shouldOpen);
          panel?.classList.toggle('is-expanded', shouldOpen);
          return;
        }

        if (shouldOpen) {
          item.open = true;
          item._openTimer = setTimeout(() => {
            item.classList.add('is-expanded');
            panel.classList.add('is-expanded');
            item._openTimer = null;
          }, 16);
          return;
        }

        item.classList.remove('is-expanded');
        panel.classList.remove('is-expanded');
        const close = (event) => {
          if (event && event.target !== panel) return;
          if (
            event &&
            event.propertyName &&
            event.propertyName !== 'grid-template-rows' &&
            event.propertyName !== 'opacity'
          ) {
            return;
          }
          this.clearPendingClose(item);
          if (!item.classList.contains('is-expanded')) item.open = false;
        };
        item._onPanelTransition = close;
        panel.addEventListener('transitionend', close);
        item._closeTimer = setTimeout(() => close(), 400);
      }

      clearPendingClose(item) {
        const panel = item.querySelector('.faq__panel');
        if (item._onPanelTransition && panel) {
          panel.removeEventListener('transitionend', item._onPanelTransition);
        }
        item._onPanelTransition = null;
        if (item._closeTimer) {
          clearTimeout(item._closeTimer);
          item._closeTimer = null;
        }
        if (item._openTimer) {
          clearTimeout(item._openTimer);
          item._openTimer = null;
        }
      }
    }

    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-info-tabs')) {
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.navButtons = Array.from(this.querySelectorAll('.product-info-tabs__tab'));
        this.items = Array.from(this.querySelectorAll('.product-info-tabs__item'));
        this.mql = window.matchMedia('(min-width: 750px)');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onTabClick = this.onTabClick.bind(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);

        this.navButtons.forEach((button) => button.addEventListener('click', this.onTabClick));
        this.items.forEach((item) => {
          item.classList.toggle('is-expanded', item.open);
          item.querySelector('summary')?.addEventListener('click', this.onSummaryClick);
        });
        this.mql.addEventListener('change', this.onMediaChange);

        if (this.mql.matches) {
          this.openTab(this.dataset.firstTab || 'description');
        }

        if (window.location.hash === '#size-guide') {
          this.openTab('size', { scroll: true });
        }
      }

      disconnectedCallback() {
        this.navButtons.forEach((button) => button.removeEventListener('click', this.onTabClick));
        this.items.forEach((item) => {
          item.querySelector('summary')?.removeEventListener('click', this.onSummaryClick);
        });
        this.mql.removeEventListener('change', this.onMediaChange);
      }

      onTabClick(event) {
        this.openTab(event.currentTarget.dataset.tab);
      }

      onSummaryClick(event) {
        if (this.mql.matches) return;

        event.preventDefault();
        const item = event.currentTarget.closest('.product-info-tabs__item');
        if (!item) return;
        this.animateItem(item, !item.classList.contains('is-expanded'));
      }

      onMediaChange() {
        if (this.mql.matches) {
          const openItem = this.items.find((item) => item.open);
          this.openTab((openItem && openItem.dataset.tab) || this.dataset.firstTab || 'description');
        }
      }

      animateItem(item, shouldOpen) {
        const panel = item.querySelector('.product-info-tabs__panel');
        if (!panel || this.reduceMotion.matches || typeof panel.animate !== 'function') {
          item.open = shouldOpen;
          item.classList.toggle('is-expanded', shouldOpen);
          return;
        }

        if (item._panelAnimation) {
          item._panelAnimation.cancel();
          item._panelAnimation = null;
          panel.style.height = '';
          panel.style.overflow = '';
        }

        item.classList.toggle('is-expanded', shouldOpen);

        if (shouldOpen) {
          panel.style.overflow = 'hidden';
          panel.style.height = '0px';
          item.open = true;
          const endHeight = panel.scrollHeight;
          const animation = panel.animate(
            [
              { height: '0px', opacity: 0 },
              { height: `${endHeight}px`, opacity: 1 },
            ],
            { duration: 320, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
          item._panelAnimation = animation;
          Promise.resolve(animation.finished)
            .catch(() => {})
            .then(() => {
              if (item._panelAnimation !== animation) return;
              panel.style.height = '';
              panel.style.overflow = '';
              item._panelAnimation = null;
            });
          return;
        }

        const startHeight = panel.scrollHeight;
        panel.style.overflow = 'hidden';
        const animation = panel.animate(
          [
            { height: `${startHeight}px`, opacity: 1 },
            { height: '0px', opacity: 0 },
          ],
          { duration: 260, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
        );
        item._panelAnimation = animation;
        Promise.resolve(animation.finished)
          .catch(() => {})
          .then(() => {
            if (item._panelAnimation !== animation) return;
            item.open = false;
            panel.style.height = '';
            panel.style.overflow = '';
            item._panelAnimation = null;
          });
      }

      openTab(tabName, options = {}) {
        if (!tabName) return;

        const desktop = this.mql.matches;

        this.items.forEach((item) => {
          const isMatch = item.dataset.tab === tabName;
          if (desktop || options.scroll) {
            if (item._panelAnimation) {
              item._panelAnimation.cancel();
              item._panelAnimation = null;
              const panel = item.querySelector('.product-info-tabs__panel');
              if (panel) {
                panel.style.height = '';
                panel.style.overflow = '';
              }
            }
            item.open = isMatch;
            item.classList.toggle('is-expanded', isMatch);
          } else if (isMatch) {
            this.animateItem(item, true);
          }
        });

        this.navButtons.forEach((button) => {
          const isMatch = button.dataset.tab === tabName;
          button.classList.toggle('is-active', isMatch);
          button.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });

        if (!options.scroll) return;

        const item = this.items.find((entry) => entry.dataset.tab === tabName);
        const target = desktop ? this : item || this;
        requestAnimationFrame(() => this.scrollToPanel(target));
      }

      scrollToPanel(target) {
        if (!target) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const header = document.querySelector('sticky-header, .shopify-section-header-sticky');
        const headerOffset = header ? Math.round(header.getBoundingClientRect().height) : 0;
        const top = Math.max(target.getBoundingClientRect().top + window.scrollY - headerOffset - 8, 0);

        window.scrollTo({
          top,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });

        if (!target.hasAttribute('tabindex')) {
          target.setAttribute('tabindex', '-1');
        }
        target.focus({ preventScroll: true });
      }
    }

    customElements.define('product-info-tabs', ProductInfoTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
